export default __webpack_public_path__ + "static/media/multiuser.4eaabe02.svg";